/**
 * SIDE PANEL — Pannello laterale generico che scivola da destra.
 * Usato per: TaskForm, AddRelationDrawer, Crea Azienda inline, etc.
 *
 * <p>Il pannello si chiude SOLO tramite i pulsanti interni:
 * <ul>
 *   <li>X nell'header (sempre presente).</li>
 *   <li>Salva / Annulla / Indietro / ecc. nel footer o body del consumer.</li>
 * </ul>
 * Click sull'overlay (sfondo oscurato) NON chiude: comportamento voluto per
 * evitare perdita accidentale dei dati di inserimento/modifica.
 */

import type { ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface SidePanelProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  width?: number;
  /** Slot opzionale per bottoni fissi in basso (es. Salva/Annulla dei form). */
  footer?: ReactNode;
}

export function SidePanel({ title, onClose, children, width = 400, footer }: SidePanelProps) {
  return (
    <>
      {/* Overlay decorativo: oscura il resto della pagina ma NON chiude al click
          (chiusura solo via bottoni interni → evita perdita dati accidentale). */}
      <div className="side-panel-overlay" />
      {/* Panel */}
      <div className="side-panel" style={{ width }}>
        <div className="side-panel__header">
          <h3>{title}</h3>
          <IconButton onClick={onClose} size="small" className="side-panel-close">
            <CloseIcon />
          </IconButton>
        </div>
        <div className="side-panel__body">
          {children}
        </div>
        {footer && (
          <div className="side-panel__footer">
            {footer}
          </div>
        )}
      </div>
    </>
  );
}
